import { render, staticRenderFns } from "./detail-component-tabs.vue?vue&type=template&id=9bcb7748&scoped=true"
import script from "./detail-component-tabs.vue?vue&type=script&lang=ts"
export * from "./detail-component-tabs.vue?vue&type=script&lang=ts"
import style0 from "./detail-component-tabs.vue?vue&type=style&index=0&id=9bcb7748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcb7748",
  null
  
)

export default component.exports